import { Button, Typography, Box } from '@mui/joy';
import { useNavigate } from 'react-router-dom';

import MainLayout from '../../components/Layouts/MainLayout';

const Page500 = () => {
  const navigate = useNavigate();
  return (
    <MainLayout title="500">
      <Box sx={{ textAlign: 'center', marginTop: '20px' }}>
        <Typography level="h3">Oops, we have a problem.</Typography>
        <Typography level="h4"> Please try again later.</Typography>
        <Button onClick={() => navigate(-1)}>Go back</Button>
      </Box>
    </MainLayout>
  );
};

export default Page500;
